/** Person / address field limits — keep in sync with backend `shared/constants/personFields.ts`. */

export const PERSON_FIRST_NAME_MAX_LENGTH = 50;
export const PERSON_LAST_NAME_MAX_LENGTH = 50;
export const PERSON_EMAIL_MAX_LENGTH = 254;
export const STREET_ADDRESS_MAX_LENGTH = 200;

/** Patient and lead legal names (wider than staff). */
export const PATIENT_NAME_MAX_LENGTH = 100;

/** Free-text note on a patient chart. */
export const PATIENT_NOTES_MAX_LENGTH = 1000;
